import { Skeleton } from '@/component/ui/skeleton'
import { useSize } from 'ahooks'
import React, { useRef } from 'react'

export function CardSkeleton({
  num = 20,
  className = '',
  columnWidth = 255,
  source = '',
}: {
  num?: number
  className?: string
  columnWidth?: number
  source?: string
}) {
  const $container = useRef<HTMLDivElement>(null)
  const size = useSize($container)
  const actualCols = Math.floor((size?.width ?? 0) / columnWidth)
  return (
    <div ref={$container} className={`grid gap-4 ${className}`} style={{ gridTemplateColumns: `repeat(${actualCols},1fr)` }}>
      {source === 'fabric-case-collection' ? (
        <>
          {Array.from({ length: num }).map((_, i) => (
            <div
              key={i}
              className="group relative overflow-hidden block rounded-lg border border-muted-foreground-2/30 bg-background"
            >
              <div className="p-2 flex gap-1 h-45">
                <div className="w-full h-41">
                  <Skeleton className="w-full h-41" />
                </div>
                <div className="flex flex-col h-45 gap-1">
                  <Skeleton className="h-20 aspect-square" />
                  <Skeleton className="h-20 aspect-square" />
                </div>
              </div>
              <div className="p-2 mt-2">
                <Skeleton className="h-5 w-full mb-2" />
                <div className="flex justify-between">
                  <Skeleton className="h-4 w-16" />
                  <Skeleton className="h-4 w-28" />
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {Array.from({ length: num }).map((_, i) => (
            <div
              key={i}
              className="group relative overflow-hidden block rounded-lg border border-muted-foreground-2/30 bg-background"
            >
              <Skeleton className="w-full aspect-square" />
              <div className="p-2">
                {/*<div className="flex justify-end mb-1">*/}
                {/*  <Skeleton className="h-6 w-6 rounded-full" />*/}
                {/*</div>*/}
                <Skeleton className="h-5 w-full mb-2" />
                <div className="flex items-center justify-between mb-2">
                  <Skeleton className="h-6 w-6 rounded-full" />
                  <Skeleton className="h-6 w-20" />
                </div>
                <div className="flex justify-between">
                  <Skeleton className="h-4 w-16" />
                  <Skeleton className="h-4 w-16" />
                </div>
                <div className="mt-2">
                  <Skeleton className="h-4 w-full" />
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  )
}